import appConfig from "@core/config";
import type {
  LcmsActivityDto,
  LcmsExtendedActivityDto,
} from "@core/typesV2/lcms";
import { NavigateFunction } from "react-router-dom";

import AxiosServiceV2, { type TokenHandlers } from "./axiosServiceV2";

export default class LcmsActivityService extends AxiosServiceV2 {
  constructor(tokenHandlers: TokenHandlers, navigateTo: NavigateFunction) {
    super(
      `${appConfig.LEARNING_BASE_URL}/api/v1/lcms/activities/`,
      tokenHandlers,
      navigateTo,
    );
  }

  getActivities(activityIds: string[]) {
    return this.post<LcmsActivityDto[], string[]>(`batch-get`, activityIds);
  }

  getActivityById(activityId: string) {
    return this.get<LcmsExtendedActivityDto>(activityId);
  }
}
